<template>
  <div>
    <button
      style="display: none"
      type="button"
      class="btn-select-sub-category-item-modal"
      data-bs-toggle="modal"
      data-bs-target="#modalSelectSubCategoryItem"
    ></button>
    <!-- Opened from AddItem via new Modal().show() + the shared #custom-overlay
         (same proven pattern as AddOptionGroup). z-index sits above the
         AddItem modal (1055) so it stacks on top without hiding it; its Bootstrap
         backdrop stays at 1050 (below AddItem) so there is no black screen.
         z-index must also clear the app sidenav (.sidenav, z-index: 9999 in
         _navbar-vertical.scss) because .main-content wraps <router-view> with
         only `position: relative` (no z-index), so it does not create its own
         stacking context — any position:fixed modal deep inside is compared
         directly against the sidenav. This modal's `.modal-width` is min-width:
         80%, wide enough to extend under the sidenav's left strip, which was
         swallowing clicks/hover on the search input there. -->
    <div
      class="modal fade"
      id="modalSelectSubCategoryItem"
      tabindex="-1"
      aria-hidden="true"
      style="z-index: 10056"
    >
      <div class="modal-dialog modal-dialog-centered modal-width">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Add Items</h5>
            <i
              style="cursor: pointer"
              class="material-icons btn-close-modal-select-sub-category justify-content-end"
              data-bs-dismiss="modal"
              aria-label="Close"
              >clear</i
            >
          </div>
          <div
            class="modal-body"
            style="overflow-y: unset; padding: 0px; padding-top: 10px"
          >
            <!-- Category tabs: scrollable horizontally -->
            <div
              class="mt-3"
              style="display: flex; overflow-x: auto; white-space: nowrap"
            >
              <ul id="general-tab" class="nav nav-tabs">
                <li
                  class="nav-item"
                  v-for="(item, key) in categoryDropdown"
                  :key="key"
                >
                  <a
                    :id="'nav_sub_cat_item_' + key"
                    class="nav-link category-tab"
                    :class="{ active: categoryId == item.value }"
                    @click="changeCategory(item.value)"
                    >{{ item.label }}</a
                  >
                </li>
              </ul>
            </div>

            <!-- Search bar (only search box + select all) -->
            <div class="search">
              <div class="row align-items-center mt-0 g-2">
                <!-- Search input -->
                <div class="col-12 col-sm-6" style="margin-top: 0px">
                  <input
                    class="nosubmit"
                    type="search"
                    id="keyword_search_sub_category"
                    v-model="searchKeyword"
                    name="keyword_search_sub_category"
                    placeholder="search"
                    @input="onChangesearchKeyword"
                  />
                </div>
                <!-- Select all button -->
                <div
                  class="col-12 col-sm-6 d-flex justify-content-end"
                  style="margin-top: 0px"
                >
                  <material-button class="action-btn" @click="selectAllItem()">
                    Select all
                  </material-button>
                </div>
              </div>
            </div>

            <!-- Item grid -->
            <div class="item-list">
              <div class="content-item">
                <div class="col-12 list-item" v-if="items.length > 0">
                  <div
                    class="item-css"
                    v-for="item in items"
                    :key="item.item_id"
                    :class="[
                      'item-' + item.item_id,
                      { 'item-locked': isSubCategoryItem(item) },
                    ]"
                    @click="selectItem(item.item_id)"
                  >
                    <img class="item-img" :src="item.image" alt="" />
                    <div class="item-info">
                      <div class="item-no">{{ item?.item_no }}</div>
                      <div class="item-name">{{ item?.item_name }}</div>
                      <!-- A sub category cannot be nested under another sub category. -->
                      <div v-if="isSubCategoryItem(item)" class="item-badge">
                        Sub Category
                      </div>
                    </div>
                  </div>
                </div>
                <div class="empty-state" v-else>No item available</div>
              </div>
            </div>
          </div>

          <!-- Footer actions -->
          <div
            class="modal-footer"
            style="align-items: center; justify-content: center"
          >
            <material-button
              class="mx-2 btn btn-sm btn-background"
              @click="addItem()"
            >
              Add {{ "(" + idActive.length + ")" }}
            </material-button>
            <material-button
              class="mx-2 btn btn-sm btn-background"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              Cancel
            </material-button>
          </div>
          <material-loading :active="loaderActive" />
        </div>
      </div>
    </div>
    <div class="position-fixed top-1 end-1 z-index-9999 message-success">
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import MaterialButton from "@/components/MaterialButton.vue";
import ItemService from "../services/product/item.service";
import MaterialLoading from "@/components/MaterialLoading.vue";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";

export default {
  name: "select-sub-category-item",
  components: {
    MaterialButton,
    MaterialLoading,
    MaterialSnackbar,
  },
  props: {
    keyReload: {
      type: String,
      required: true,
    },
    menusetId: {
      type: Number,
      default: 0,
    },
    // Items already added on the main modal, so they can be shown as active
    // (and locked) when the picker is reopened.
    selectedItems: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      snackbar: null,
      message: "",
      idActive: [],
      items: [],
      searchKeyword: "",
      searchTimerId: null,
      categoryDropdown: [],
      categoryId: 0,
      loaderActive: false,
      isCloseModal: false,
      // item_no set of items already added on the main modal.
      selectedNos: new Set(),
    };
  },
  methods: {
    // An item that is itself a sub category cannot be placed under another sub
    // category. The is_sub_category flag alone is not enough: some legacy child
    // items carry it with choice = 0, so a real sub category needs both.
    isSubCategoryItem(item) {
      return item?.is_sub_category == 1 && item?.choice == 1;
    },

    async getListItem() {
      if (!this.menusetId) {
        this.items = [];
        return;
      }
      this.showLoader();
      var dataForm = {
        keyword: this.searchKeyword,
        set_id: this.menusetId,
        category_id: this.categoryId,
      };

      await ItemService.getMainItem(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.items = response.data.data.items;
            this.reloadItemActive();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.message = error;
          this.hideLoader();
        }
      );
    },

    // Re-apply the highlight for items that are already added (selectedNos) or
    // newly selected in this session (idActive) when the grid re-renders.
    reloadItemActive() {
      setTimeout(() => {
        this.items.forEach((item) => {
          const no = (item.item_no ?? "").toString();
          const isActive =
            (no && this.selectedNos.has(no)) ||
            this.idActive.some((it) => it.item_id === item.item_id);
          if (isActive) {
            var name = ".item-" + item.item_id;
            if (!$(name).hasClass("active")) {
              $(name).addClass("active");
            }
          }
        });
      }, 100);
    },

    addItem() {
      this.$emit(
        "add-sub-category-items",
        this.idActive.map((it) => ({
          item_id: it.item_id,
          item_no: it.item_no,
          item_name: it.item_name,
        }))
      );
      $(".btn-close-modal-select-sub-category").click();
    },

    onChangesearchKeyword(event) {
      if (this.isCloseModal) {
        return;
      }

      this.searchKeyword = event.target.value;
      clearTimeout(this.searchTimerId);
      this.searchTimerId = setTimeout(() => {
        this.getListItem();
      }, 1000);
    },

    selectAllItem() {
      this.items.forEach((item) => {
        // Skip items already added on the main modal, and sub category items.
        if (this.selectedNos.has((item.item_no ?? "").toString())) {
          return;
        }
        if (this.isSubCategoryItem(item)) {
          return;
        }
        if (!this.idActive.some((it) => it.item_id === item.item_id)) {
          this.idActive.push({
            item_id: item.item_id,
            item_no: item.item_no,
            item_name: item.item_name,
          });
          var name = ".item-" + item.item_id;
          if (!$(name).hasClass("active")) {
            $(name).addClass("active");
          }
        }
      });
    },

    selectItem(id) {
      var itemInList = this.items.find((it) => it.item_id === id);

      // A sub category cannot be added under another sub category.
      if (this.isSubCategoryItem(itemInList)) {
        this.snackbar = "danger";
        this.message =
          "This item is a sub category. It cannot be added under another sub category.";
        this.setTimeOutNotification();
        return;
      }

      // Items already added on the main modal stay active and cannot be toggled
      // off here; they are removed via the delete icon on the main modal.
      const no = (itemInList?.item_no ?? "").toString();
      if (no && this.selectedNos.has(no)) {
        alert(
          "This item is already added. To remove it, close this popup and use the delete icon on the main modal."
        );
        return;
      }

      var name = ".item-" + id;
      var indexToDelete = this.idActive.findIndex((it) => it.item_id === id);

      if (indexToDelete > -1) {
        this.idActive.splice(indexToDelete, 1);
        $(name).removeClass("active");
      } else {
        var item = this.items.find((it) => it.item_id === id);
        this.idActive.push({
          item_id: id,
          item_no: item ? item.item_no : "",
          item_name: item ? item.item_name : "",
        });
        $(name).addClass("active");
      }
    },

    changeCategory(categoryId) {
      this.categoryId = categoryId;
      clearTimeout(this.searchTimerId);
      this.searchTimerId = setTimeout(() => {
        this.getListItem();
      }, 100);
    },

    async getCategoryByMenuSetDropdown() {
      if (!this.menusetId) {
        this.categoryDropdown = [];
        this.categoryId = 0;
        return;
      }
      var dataForm = {
        menu_set_id: this.menusetId,
        merchantId: this.$route.params.merchant_id,
        // Restrict to MAIN categories of the current menu set only.
        // Without this flag the endpoint falls back to returning every category
        // across all menu sets.
        isModifierOptionGroup: true,
      };

      await ItemService.getCategoryByMenuSetDropdown(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            var categoryDropdown = response.data.data;

            if (categoryDropdown.length) {
              this.categoryId = categoryDropdown[0].value;
            }

            this.categoryDropdown = categoryDropdown;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.setTimeOutNotification();
        }
      );
    },

    clearData() {
      this.idActive = [];
      this.items = [];
      this.searchKeyword = "";
      this.categoryDropdown = [];
      this.categoryId = 0;
      $(".item-css").removeClass("active");
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
  },
  watch: {
    async keyReload() {
      this.isCloseModal = true;
      this.clearData();
      // Seed the already-added set from the main modal's current list so those
      // items show as active when the grid loads.
      this.selectedNos = new Set(
        (this.selectedItems || []).map((it) => (it.item_no ?? "").toString())
      );
      setTimeout(() => {
        this.isCloseModal = false;
      }, 500);
      this.showLoader();
      await this.getCategoryByMenuSetDropdown();
      await this.getListItem();
      this.hideLoader();
    },
  },
};
</script>

<style scoped>
.modal-content {
  max-height: 85vh;
  overflow-y: auto;
  padding-bottom: 25px;
}
.modal-body .row {
  margin-top: 10px;
}
.modal-width {
  min-width: 80%;
}
.search {
  padding: 15px 5px;
  border-bottom: 1px solid #dee2e6;
}
.search > .row > div {
  margin-top: 15px;
}
input[type="search"] {
  border: none;
  background: transparent;
  margin: 0;
  padding: 7px 8px;
  font-size: 14px;
  color: inherit;
  border: 1px solid transparent;
  border-radius: inherit;
}
input[type="search"]::placeholder {
  color: #bbb;
  text-align: left;
  font-weight: normal;
}
input[type="search"]:focus {
  border-color: #72959d;
  outline: none;
  border: none;
  border-bottom: 2px solid #72959d;
}
input.nosubmit {
  border-bottom: 1px solid #d2d2d2;
  width: 100%;
  padding: 9px 4px 9px 40px;
  background: transparent
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' class='bi bi-search' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'%3E%3C/path%3E%3C/svg%3E")
    no-repeat 13px center;
}
.action-btn {
  float: right;
  margin-right: 17px;
}
.content-item {
  width: 100%;
  max-height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
}
.item-css {
  cursor: pointer;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 12px;
  width: calc(25% - 12px);
  min-height: 82px;
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fff;
  position: relative;
  transition: border-color 0.15s ease, box-shadow 0.15s ease,
    background-color 0.15s ease;
}
.item-css:hover {
  border-color: #44bd32;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}
.item-img {
  width: 54px;
  height: 54px;
  object-fit: cover;
  border-radius: 8px;
  flex-shrink: 0;
  background: #f3f4f6;
}
.item-info {
  min-width: 0;
  flex: 1;
}
.item-no {
  font-size: 11px;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  margin-bottom: 2px;
}
.item-name {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  line-height: 1.3;
  word-break: break-word;
}
.list-item {
  padding: 16px 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 12px;
}
.active {
  border-color: #44bd32;
  background: #f0fbf4;
}
.active::after {
  content: "\2713";
  position: absolute;
  top: 8px;
  right: 8px;
  width: 18px;
  height: 18px;
  background: #44bd32;
  color: #fff;
  border-radius: 50%;
  font-size: 11px;
  line-height: 18px;
  text-align: center;
  font-weight: 700;
}
.item-locked {
  opacity: 0.55;
  cursor: not-allowed;
  background: #f9fafb;
}
.item-locked:hover {
  border-color: #e5e7eb;
  box-shadow: none;
}
.item-badge {
  display: inline-block;
  margin-top: 4px;
  padding: 1px 6px;
  border-radius: 4px;
  background: #e5e7eb;
  color: #6b7280;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}
.empty-state {
  width: 100%;
  text-align: center;
  color: #9ca3af;
  font-size: 14px;
  padding: 48px 20px;
}
.item-list {
  overflow-x: hidden;
}
.item-list::-webkit-scrollbar {
  width: 7px;
}
.item-list::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.item-list::-webkit-scrollbar-thumb {
  background: #888;
}
.item-list::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.modal-content {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
#general-tab {
  border-bottom: 1px solid #e5e7eb;
  padding: 0 8px;
}
#general-tab .nav-item {
  width: fit-content;
  text-align: center;
}
.category-tab {
  border: none !important;
  background: transparent !important;
  color: #6b7280;
  font-size: 14px;
  font-weight: 500;
  padding: 10px 14px;
  margin-bottom: -1px;
  border-bottom: 2px solid transparent !important;
}
.category-tab:hover {
  color: #111827;
}
.category-tab.active {
  color: #44bd32 !important;
  border-bottom: 2px solid #44bd32 !important;
}

@media (max-width: 1024px) {
  .item-css {
    width: calc(50% - 12px);
  }
  .list-item {
    padding: 15px;
  }
}

/* ── Responsive overrides (HTML-only approach via media query) ── */
@media (max-width: 767px) {
  .modal-width {
    min-width: 95%;
    margin: 0.5rem auto;
  }
  .modal-content {
    max-height: 92vh;
    padding: 10px;
  }
  .item-css {
    width: calc(50% - 12px);
  }
  .list-item {
    padding: 10px;
  }
  .content-item {
    max-height: 380px;
  }
  .action-btn {
    float: none;
    margin-right: 0;
    width: 100%;
  }
}

@media (max-width: 500px) {
  .item-css {
    width: 100%;
  }

  .search > div > div {
    margin-bottom: 10px;
  }
}
</style>
